export const ROUTES = {
  USERS_ME: '/users/profile',
  // New self-edit surface (STAFF_PROFILE_ACCESS_PLAN.md §21j) - deliberately
  // separate from USERS_ME above, not a rename of it.
  USERS_PROFILE: '/users/profile',
  USER_PROFILE_PHOTO_PRESIGN: '/users/profile/photo/presign',
  USER_PROFILE_PHOTO_BY_ID: fileId => `/users/profile/photo/${fileId}`,
  USER_PROFILE_PHOTO: '/users/profile/photo',
  GET_CLINICS: '/auth/staffs/clinics',
  SELECT_CLINIC: '/auth/staffs/clinic-selection',
  PATIENT_GET_CLINICS: '/auth/patients/clinics',
  PATIENT_SELECT_CLINIC: '/auth/patients/clinic-selection',
  PREFERENCES: '/me/preferences/language',
};
